import { chainId, chain } from "../lib/wallet";
import { cn } from "./cn";

/**
 * NetworkBadge — read-only network indicator (WO#1 §21).
 *
 * Sources chain data from the existing `lib/wallet.ts` env-driven
 * config. Does NOT hardcode chain data (WO#1 §33). Does NOT expose
 * network switching UI in WO#1 — network switching lives inside the
 * existing PurchasePanel + chain-switch machinery and is not
 * duplicated here.
 */
export function NetworkBadge() {
  const isTestnet = chainId !== 8453;
  return (
    <div
      data-testid="network-badge"
      className={cn(
        "hidden sm:inline-flex items-center gap-2 shrink-0 whitespace-nowrap",
        "font-mono text-[10px] font-medium tracking-[0.14em] uppercase",
        "text-text-secondary hover:text-text-primary",
        "px-2.5 2xl:px-3 h-7 neon-glass pill-ghost",
      )}
      aria-label={`Network: ${chain?.name ?? String(chainId)}`}
    >
      <span
        aria-hidden
        className={cn(
          "inline-block h-1.5 w-1.5 rounded-pill",
          isTestnet ? "bg-state-warning" : "bg-state-success",
        )}
        style={{
          boxShadow: isTestnet
            ? "0 0 8px rgba(255,176,86,0.9)"
            : "0 0 8px rgba(55,224,200,0.9)",
        }}
      />
      <span data-testid="network-name">{chain?.name ?? "Unknown"}</span>
    </div>
  );
}
